import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { PublicidadService } from '../publicidad.service';
import { PublicidadPreviewComponent } from '../publicidad-preview/publicidad-preview.component';

@Component({
  selector: 'app-publicidad-create',
  templateUrl: './publicidad-create.component.html',
  styleUrls: ['./publicidad-create.component.scss']
})
export class PublicidadCreateComponent implements OnInit {

  fileToUpload?: File | null;
  archivo: FormControl = new FormControl();
  mensaje: FormControl = new FormControl();
  imgFile: any;
  imagenInicial: boolean = false;

  mostrarVistaPrevia: boolean = true;

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.mostrarVistaPrevia = window.innerWidth >= 1200;
  }

  form: FormGroup = new FormGroup({});

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: PublicidadService,
    public formatter: FormatterService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      titulo: ['', [Validators.required]],
      tipo: [1, [Validators.required]],
      url: [''],
      descripcion: [''],
    });
    if (window.innerWidth < 1200) this.mostrarVistaPrevia = false;
  }

  guardar(): void {
    if (!this.fileToUpload) {
      this.alerts.addAlert("Debe cargar una imagen.", "warning");
      return;
    }
    if (this.form.valid) {
      this.loading.show();
      this.service.insert(this.fileToUpload, this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Publicidad registrada con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro de publicidad.", "danger");
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  onImageChange(e: any): void {
    if (!e) return;
    let files = e.target.files;
    const sizeLimit = 52428800;
    if (files.item(0).size > sizeLimit) {
      this.alerts.addAlert("El archivo es demasiado grande para ser subido.", "danger");
      this.fileToUpload = null;
      return;
    }
    this.fileToUpload = files.item(0);
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.imgFile = event.target.result;
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  showPreview() {
    const modalRef = this.modalService.open(PublicidadPreviewComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true });
    modalRef.componentInstance.imgFile = this.imgFile;
    modalRef.componentInstance.element = this.form.value;
    modalRef.result.then((result: any) => { }, (reason: any) => { });
  }
}
